import { FC } from 'react';
import { ResumenBase } from './ResumenBase';
import { Phone } from '../../model/Phone';

const SEPARATOR: string = '-';
const ADD_SEPARATOR_PATTERN = /\B(?=(\d{4})+(?!\d))/g;

type Props = {
  getPhone: () => Phone | undefined;
};

export const TelefonoResumen: FC<Props> = ({ getPhone }) => {
  const phone = getPhone();

  if (!phone || (!phone.prefix && !phone.telephone)) return <></>;

  return (
    <ResumenBase>
      El teléfono de contacto es
      <b> {phoneFormat(phone)}</b>.
    </ResumenBase>
  );
};

export const phoneFormat = (phone: Phone | undefined): string => {
  if (!phone) return '';
  const prefix = phone.prefix ? `(${phone.prefix}) ` : '';

  return `${prefix}${phone.telephone?.toString?.().replace(ADD_SEPARATOR_PATTERN, SEPARATOR)}`;
};
